import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { HttpService } from '../library';
import { toast } from 'react-toastify';
import exportFromJSON from 'export-from-json'
import { SystemDashboardLayout, SystemPanel } from 'library';
import SystemDatePicker from '../library/inputs/SystemDatePicker';
import { getUserId } from '../service/userService';
import moment from 'moment';
import { ToWords } from 'to-words';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";


const DeductionReport = () => {
    var dateGroup = '';
    const [dataLoader, setDataLoader] = useState(false);
    const [endDate, setEndDate] = useState();
    const toWords = new ToWords();
    const [dataResults, setDataResults] = useState([]);
    const [errors, setErrors] = useState({});
    const [payPeriodEndDate, setPayPeriodEndDate] = useState([]);


    const formValidator = () => {
        var errorMsgs = [];
        if (endDate == undefined || endDate == '' || endDate == null) {
            toast.error("Please select Pay Period End Date.");
            return false;
        }
        return true;
    }

    const searchHandler = async () => {

        if (formValidator()) {
            setErrors([]);
            const Entity = new FormData();
            //debugger;
            let date = endDate.split(":")[0];
            let payType = endDate.split(":")[1]

            let parts = date.split('/');
            let day = parts[1];
            let month = parts[0];
            let year = parts[2];

            Entity.append('EndDate', year + '-' + month + '-' + day);
            Entity.append('UserId', getUserId());
            Entity.append('PayType', payType);

            setDataLoader(true);
            setDataResults([]);
            await HttpService.post("Report/PayStubReport", Entity).then((response) => {
                setDataResults(response.data);
                setDataLoader(false);
            })
        }
        setDataLoader(false);
    }


    const PayPeriodEndDate = async () => {
        await HttpService.get("Report/PayPeriodEndDate/" + getUserId()).then((response) => {
            setPayPeriodEndDate(response.data.PayPeriodEndDateList);
        })
    }


    /**
     * @author: Sandeep Sirohi
     * @description: Export report to excel.
     */
    const excelExport = () => {
        if (dataResults != null) {
            exportFromJSON({
                data: dataResults, fileName: 'Pay Stub Report', exportType: exportFromJSON.types.csv
            });
        }
    };


    /**
     * @author:Sandeep Sirohi
     * @description: format currency for the report.
     */
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });

    /**
     * @author:Sandeep Sirohi
     * @description: format number with decimal places for the report.
     */
    const numberFormatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    useEffect(() => {
        // searchHandler();
        PayPeriodEndDate();
    }, [])

    /**
     * @author: Sandeep Sirohi
     * @description: Export report to pdf.
     */
    const downloadPdfDocument = () => {
        const input = document.getElementById('payStubReport');

        // Set padding and font size for the report before rendering
        input.style.setProperty('padding', '0 20px', 'important');
        input.style.setProperty('font-size', '12px', 'important');

        // Start script for Paystub report mobile view
        const input1 = document.getElementById('paystub-tbl1');
        input1.style.setProperty('width', '50%', 'important');

        const input2 = document.getElementById('paystub-tbl2');
        input2.style.setProperty('width', '50%', 'important');

        const input3 = document.getElementById('paystub-tbl3');
        input3.style.setProperty('width', '50%', 'important');

        const input4 = document.getElementById('paystub-tbl4');
        input4.style.setProperty('width', '50%', 'important');
        // End script for Paystub report mobile view

        // Adjust padding for td elements
        const tdElements = input.querySelectorAll('td');
        tdElements.forEach(function (td) {
            td.style.padding = '1px'; // Adjust the padding for <td> elements
        });

        const elements = input.querySelectorAll('.force-page-break');
        elements.forEach((el) => {
            el.classList.add('page-break-before');
        });
        // Define options for html2pdf.js
        const options = {
            margin: [10, 2, 10, 2],
            filename: "PayStub.pdf",
            image: { type: 'png', quality: 1 }, // Highest image quality
            html2canvas: {
                scale: 3, // You can try scale: 1.5 or 2 for better quality
                useCORS: true,
                logging: true, // Enable logging for debugging
                letterRendering: true, // Improves text sharpness
            },
            jsPDF: {
                unit: 'mm', // Units for jsPDF
                format: 'a4',
                orientation: 'portrait',
                compressPDF: true // Optional, compress the PDF to save space
            },
            pagebreak: { mode: 'avoid-all' }
        };

        // Generate PDF using html2pdf.js
        html2pdf().from(input).set(options).save();

        // Reset padding after PDF generation
        setTimeout(() => {
            input.style.setProperty('padding', '', 'important');
            input1.style.setProperty('width', '', 'important');
            input2.style.setProperty('width', '', 'important');
            input3.style.setProperty('width', '', 'important');
            input4.style.setProperty('width', '', 'important');
        }, 0);
    };


    //Sandeep: Convert decimal part of amount to words.
    const convertDecimal = (number) => {
        if (!Number.isInteger(number)) {
            return " and " + number.toFixed(2).toString().split(".")[1] + " / 100";
        }
    }

    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title="Paystub Detail" tagLine="" />
                <div className="container-fluid fieldsetGridAndForm  mt-80">
                    <SystemPanel
                        toolbar={[<button key={Math.random()} className="btn btn-default" onClick={downloadPdfDocument}><span class="icon-download"></span> Download</button>]}
                        label="Report" showAdd={false} showRefresh={false} showArchive={false}>
                        <div className="row pl-xl-20 pr-xl-20" style={{ margin: '0 0px' }}>
                            <div className="col-md-12 col-12">
                                <div className=" row mt-5 mb-5 col-md-6">
                                    <div className="col-md-5">
                                        <label >Pay Period End Date:</label>
                                    </div>
                                    <div className="col-sm mb-1">
                                        <select className="border  selectboxEdit" value={endDate} onChange={(e) => {
                                            setEndDate(e.target.value);
                                        }}>
                                            <option value="">Pay period end date</option>
                                            {
                                                payPeriodEndDate ? payPeriodEndDate.map((val, index) => {
                                                    return (<option key={index + 1} value={moment(val.EndDate).format("MM/DD/YYYY") + ':' + val.PayType}>{moment(val.EndDate).format("MM/DD/YYYY")}</option>);
                                                }) : ""
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <button data-html2canvas-ignore onClick={(e) => { searchHandler() }} title="Generate report" className="btn btnSave">Search</button>
                                    </div>
                                </div>
                                <hr style={{ height: '1px', color: '#000000' }} />
                            </div>

                            {dataLoader ? <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div> :
                                (dataResults && dataResults.EmployeeDetail) ?
                                    <div id="payStubReport" >
                                        <div className="row table-responsive" >

                                            <div className="col-md-12">
                                                <img width="150"
                                                    src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'}
                                                    className="logoDashboardSidebar  mt-2 mb-2" />
                                            </div>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <table className="invoice-header">
                                                            <tr>
                                                                <td colSpan="2"><b>Trailboss Enterprises, Inc.</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">
                                                                    {/*<div dangerouslySetInnerHTML={{ __html: dataResults.EmployeeDetail.OfficeAddress }} />*/}
                                                                    {/*<span>201 E. 3rd Avenue</span><br />*/}
                                                                    {/*<span>ANCHORAGE, AK 99501</span><br />*/}
                                                                    {/*<span>907-338-8243</span>*/}
                                                                    <span>{dataResults.EmployeeDetail.OfficeAddressLine1}</span><br />
                                                                    <span>{dataResults.EmployeeDetail.OfficeAddressLine2}</span><br />
                                                                    <span>{dataResults.EmployeeDetail.OfficePhone}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td valign="top">
                                                                    <b>
                                                                        PAID:
                                                                    </b>
                                                                </td>
                                                                <td>
                                                                    <b>
                                                                        {
                                                                            toWords.convert
                                                                                (
                                                                                    dataResults.TotalSummary &&
                                                                                        dataResults.TotalSummary.length > 0
                                                                                        && dataResults.TotalSummary[0].TotalEarning ?
                                                                                        Math.trunc(dataResults.TotalSummary[0].TotalEarning) : 0
                                                                                )
                                                                        }
                                                                        {
                                                                            convertDecimal(
                                                                                dataResults.TotalSummary &&
                                                                                    dataResults.TotalSummary.length > 0
                                                                                    && dataResults.TotalSummary[0].TotalEarning ? dataResults.TotalSummary[0].TotalEarning : 0
                                                                            )
                                                                        }
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td valign="top">
                                                                    <b>To the order Of</b>
                                                                </td>
                                                                <td>
                                                                    {dataResults.EmployeeDetail.Name} <br />
                                                                    {dataResults.EmployeeDetail.AddressLine1 ? <span>{dataResults.EmployeeDetail.AddressLine1}<br /></span> : ''}
                                                                    {dataResults.EmployeeDetail.AddressLine2 ? <span>{dataResults.EmployeeDetail.AddressLine2}<br /></span> : ''}
                                                                    {dataResults.EmployeeDetail.AddressLine3 ? dataResults.EmployeeDetail.AddressLine3 : ''}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td className="d-flex justify-content-end align-items-end">

                                                        <table class="invoice-header text-right " textclass="text-right">
                                                            <tr>
                                                                <td className="text-right"><b>Payment:</b></td>
                                                                <td className="text-right">{dataResults.EmployeeDetail ? dataResults.EmployeeDetail.ChequeNo : ''}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-right"><b>Ref EID:</b></td>
                                                                <td className="text-right">{dataResults.EmployeeDetail ? dataResults.EmployeeDetail.EmployeeId : ''}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-right"><b>For Period Ending:</b></td>
                                                                <td className="text-right">{moment(endDate.split(":")[0]).format("MM/DD/YYYY")}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-right"><b>Amount:</b></td>
                                                                <td className="text-right">{formatter.format(dataResults.TotalSummary && dataResults.TotalSummary.length > 0 ? dataResults.TotalSummary[0].TotalEarning : 0)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-right"><b>Date:</b></td>
                                                                <td className="text-right">{dataResults.EmployeeDetail ? moment(dataResults.EmployeeDetail.ChequeDate).format("MM/DD/YYYY") : ''}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2" className="text-right"><b>DIRECT DEPOSIT ADVICE SLIP</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2" className="text-right"><b>*** NON NEGOTIABLE ***</b></td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                            <hr style={{ height: '1px', color: '#000000' }} />
                                        </div>
                                        <div className="row">
                                            {/*Earning summary*/}
                                            <div className="col-md-6 justify-content-center pr-1 pl-0" id="paystub-tbl1">
                                                <div className="table-responsive">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="4">Earnings Summary</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th class="text-right">Hours</th>
                                                                <th class="text-right">Amount</th>
                                                                <th class="text-right">Year to Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                (dataResults.EarningSummary != null && dataResults.EarningSummary.length) > 0 ?
                                                                    dataResults.EarningSummary.map((val, index) => {
                                                                        return (<tr>
                                                                            <td>{val.Type}</td>
                                                                            <td class="text-right">{numberFormatter.format(val.Hours)}</td>
                                                                            <td class="text-right">{formatter.format(val.Amount)}</td>
                                                                            <td class="text-right">{formatter.format(val.YearToDate)}</td>
                                                                        </tr>);
                                                                    }) : ""
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                            {/*Deduction*/}
                                            <div className="col-md-6 justify-content-center p-0 pl-xl-2" id="paystub-tbl2">

                                                <div className="table-responsive">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="4">Dedcutions</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th class="text-right">Amount</th>
                                                                <th class="text-right">Year to Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                (dataResults.DeductionSummary != null && dataResults.DeductionSummary.length) > 0 ?
                                                                    dataResults.DeductionSummary.map((val, index) => {
                                                                        return (
                                                                            (val.Type == "Federal Withholding" ||
                                                                                val.Type == "Social Security Withholding" ||
                                                                                val.Type == "Medicare" ||
                                                                                val.Type == "State Withholding" ||
                                                                                val.Type == "Local Withholding") && val.YearToDate <= 0
                                                                                ? ''
                                                                                :
                                                                                (<tr>
                                                                                    <td>{val.Type}</td>
                                                                                    {val.Amount >= 0 ?
                                                                                        <td class="text-right">{formatter.format(val.Amount)}</td> :
                                                                                        <td class="text-right">({formatter.format(Math.abs(val.Amount))})</td>
                                                                                    }
                                                                                    {val.YearToDate >= 0 ?
                                                                                        <td class="text-right">{formatter.format(val.YearToDate)}</td> :
                                                                                        <td class="text-right">({formatter.format(Math.abs(val.YearToDate))})</td>
                                                                                    }
                                                                                </tr>)
                                                                        );
                                                                    }) : ""
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>

                                        </div>

                                        <div className="row">
                                            {/*Earning detail*/}
                                            <div className="col-md-6 justify-content-center pl-0 pr-1" id="paystub-tbl3">
                                                <div className="table-responsive">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="7">Earning Details</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Week</th>
                                                                <th>Type</th>
                                                                <th>Classification</th>
                                                                <th class="text-right">Hours</th>
                                                                <th class="text-right">Rate</th>
                                                                <th class="text-right">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {

                                                                (dataResults.EarningDetail != null && dataResults.EarningDetail.length > 0) ?
                                                                    dataResults.EarningDetail.map((val, index) => {
                                                                        if (dateGroup != val.WeekDate) {
                                                                            dateGroup = val.WeekDate;
                                                                            return (<tr>
                                                                                <td><b>{val.WeekDate}</b></td>
                                                                                <td>{val.Type}</td>
                                                                                <td>{val.Classification}</td>
                                                                                <td class="text-right">{numberFormatter.format(val.Hours)}</td>
                                                                                <td class="text-right">{formatter.format(val.Rate)}</td>
                                                                                <td class="text-right">{formatter.format(val.Amount)}</td>
                                                                            </tr>);

                                                                        }
                                                                        else {
                                                                            return (<tr>
                                                                                <td></td>
                                                                                <td>{val.Type}</td>
                                                                                <td>{val.Classification}</td>
                                                                                <td class="text-right">{formatter.format(val.Hours)}</td>
                                                                                <td class="text-right">{formatter.format(val.Rate)}</td>
                                                                                <td class="text-right">{formatter.format(val.Amount)}</td>
                                                                            </tr>);
                                                                        }
                                                                    }) : ""
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                            {/*Contribution summary*/}
                                            <div className="col-md-6 p-0 pl-xl-2" id="paystub-tbl4">

                                                <div className="table-responsive ">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="4">Contributions</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th class="text-right">Amount</th>
                                                                <th class="text-right">Year to Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                (dataResults.ContributionSummary != null && dataResults.ContributionSummary.length) > 0 ?
                                                                    dataResults.ContributionSummary.map((val, index) => {
                                                                        return (<tr>
                                                                            <td>{val.Type}</td>
                                                                            {val.Amount >= 0 ?
                                                                                <td class="text-right">{formatter.format(val.Amount)}</td> :
                                                                                <td class="text-right">({formatter.format(Math.abs(val.Amount))})</td>
                                                                            }
                                                                            {val.YearToDate >= 0 ?
                                                                                <td class="text-right">{formatter.format(val.YearToDate)}</td> :
                                                                                <td class="text-right">({formatter.format(Math.abs(val.YearToDate))})</td>
                                                                            }
                                                                        </tr>);
                                                                    }) : ""
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row force-page-break">
                                            {/*Summary*/}
                                            <div className="col-md-12 justify-content-center p-0">
                                                <div className="table-responsive">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="7">Summary</th>
                                                            </tr>
                                                            <tr>
                                                                <th class="text-right"></th>
                                                                <th class="text-right">Check Amount</th>
                                                                <th class="text-right">Direct Deposit</th>
                                                                <th class="text-right">Contributions</th>
                                                                <th class="text-right">Deductions</th>
                                                                <th class="text-right">Net Earnings</th>
                                                                <th class="text-right">Gross Earnings</th>
                                                            </tr>
                                                        </thead>

                                                        {
                                                            (dataResults.TotalSummary != null && dataResults.TotalSummary.length) > 1 ?
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Current</td>
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[0].ChequeDeposit)}</td>
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[0].DirectDeposit)}</td>
                                                                        {dataResults.TotalSummary[0].Contribution >= 0 ?
                                                                            <td class="text-right">{formatter.format(dataResults.TotalSummary[0].Contribution)}</td> :
                                                                            <td class="text-right">({formatter.format(Math.abs(dataResults.TotalSummary[0].Contribution))})</td>
                                                                        }

                                                                        {dataResults.TotalSummary[0].Deduction >= 0 ?
                                                                            <td class="text-right">{formatter.format(dataResults.TotalSummary[0].Deduction)}</td> :
                                                                            <td class="text-right">({formatter.format(Math.abs(dataResults.TotalSummary[0].Deduction))})</td>
                                                                        }
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[0].TotalEarning)}</td>
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[0].GrossEarning)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Year to date</td>
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[1].ChequeDeposit)}</td>
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[1].DirectDeposit)}</td>
                                                                        {dataResults.TotalSummary[1].Contribution >= 0 ?
                                                                            <td class="text-right">{formatter.format(dataResults.TotalSummary[1].Contribution)}</td> :
                                                                            <td class="text-right">({formatter.format(Math.abs(dataResults.TotalSummary[1].Contribution))})</td>
                                                                        }
                                                                        {dataResults.TotalSummary[1].Deduction >= 0 ?
                                                                            <td class="text-right">{formatter.format(dataResults.TotalSummary[1].Deduction)}</td> :
                                                                            <td class="text-right">({formatter.format(Math.abs(dataResults.TotalSummary[1].Deduction))})</td>
                                                                        }
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[1].TotalEarning)}</td>
                                                                        <td class="text-right">{formatter.format(dataResults.TotalSummary[1].GrossEarning)}</td>
                                                                    </tr>
                                                                </tbody>
                                                                : ""
                                                        }
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row">
                                            {/*Direct deposit*/}
                                            <div className="col-md-12 p-0">

                                                <div className="table-responsive">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="5">Direct Deposits</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Routing Number</th>
                                                                <th>Bank Name</th>
                                                                <th>Account Number</th>
                                                                <th>Amount</th>
                                                                <th>Year to Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                (dataResults.DirectDepositSummary != null && dataResults.DirectDepositSummary.length) > 0 ?
                                                                    dataResults.DirectDepositSummary.map((val, index) => {
                                                                        return (<tr>
                                                                            <td>{val.RoutingNumber}</td>
                                                                            <td>{val.BankName}</td>
                                                                            <td>{val.AccountNumber.replace(/\d(?=\d{4})/g, 'X')}</td>
                                                                            <td>{formatter.format(val.Amount)}</td>
                                                                            <td>{formatter.format(val.YearToDate)}</td>
                                                                        </tr>);
                                                                    }) : ""
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row">
                                            {/*Leave*/}
                                            <div className="col-md-12 justify-content-center p-0">
                                                <div className="table-responsive">
                                                    <table id="tblReport" className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="7">Leave</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th class="text-right">Beginning Balance</th>
                                                                <th class="text-right">YTD Accrued</th>
                                                                <th class="text-right">YTD Used</th>
                                                                <th class="text-right">Ending Balance</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                (dataResults.LeaveSummary != null && dataResults.LeaveSummary.length > 0) ?
                                                                    dataResults.LeaveSummary.map((val, index) => {
                                                                        return (<tr>
                                                                            <td><b>{val.Type}</b></td>
                                                                            <td class="text-right">{numberFormatter.format(val.BeginningBalance)}</td>
                                                                            <td class="text-right">{numberFormatter.format(val.YTDAccrued)}</td>
                                                                            <td class="text-right">{numberFormatter.format(val.YTDUsed)}</td>
                                                                            <td class="text-right">{numberFormatter.format(val.EndingBalance)}</td>
                                                                        </tr>);
                                                                    }) : ""
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    : ""
                            }
                        </div>
                    </SystemPanel>
                </div>
            </div >
        </div >
    </>)
};

export default DeductionReport;
